import { ReservationType, ClickToBook, OfferTypeEnum, OfferContractPaymentPeriodEnum } from './offer.interfaces';
import { AvailabilitySlot, AvailabilitySlotType, DiscountTarget, DetailsType } from './availability-slots.inferfaces';

export interface SelectOption<T> {
  label: string;
  value: T;
}

export const getOfferDetailsTypesDropdown: SelectOption<DetailsType>[] = [
  {
    label: '% off',
    value: DetailsType.PERCENT_OFF,
  },
  {
    label: 'Other',
    value: DetailsType.OTHER,
  },
];

export const getSlotTypesDropdown: SelectOption<AvailabilitySlotType>[] = [
  {
    label: 'Breakfast',
    value: AvailabilitySlotType.BREAKFAST,
  },
  {
    label: 'Lunch',
    value: AvailabilitySlotType.LUNCH,
  },
  {
    label: 'Dinner',
    value: AvailabilitySlotType.DINNER,
  },
  // {
  //   label: 'All Day',
  //   value: AvailabilitySlotType.ALL_DAY,
  // },
];

export const getDiscountTargetDropdown: SelectOption<DiscountTarget>[] = [
  {
    label: 'Food',
    value: DiscountTarget.FOOD,
  },
  {
    label: 'Drinks',
    value: DiscountTarget.DRINKS,
  },
  {
    label: 'Bill',
    value: DiscountTarget.BILL,
  },
];

export const getReservationTypeDropdown: SelectOption<ReservationType>[] = [
  {
    label: 'Reservation required',
    value: ReservationType.RESERVATION_REQUIRED,
  },
  {
    label: 'Walk-ins or reservation',
    value: ReservationType.WALK_IN_OR_RESERVATION,
  },
  {
    label: 'Walk-ins only',
    value: ReservationType.WALK_IN_ONLY,
  },
];

export const getClickToBookLabels: SelectOption<ClickToBook>[] = [
  {
    label: 'Nothing selected',
    value: null,
  },
  {
    label: 'Phone',
    value: ClickToBook.PHONE,
  },
  {
    label: 'Email',
    value: ClickToBook.EMAIL,
  },
  {
    label: 'Website',
    value: ClickToBook.WEBSITE,
  },
];

export const getOfferContractPaymentPeriodLabels: SelectOption<OfferContractPaymentPeriodEnum>[] = [
  {
    label: 'ANNUAL PAYMENT',
    value: OfferContractPaymentPeriodEnum.ANNUAL_PAYMENT
  },
  {
    label: 'MONTHLY PAYMENT',
    value: OfferContractPaymentPeriodEnum.MONTHLY_PAYMENT
  },
  {
    label: 'FREE LISTING',
    value: OfferContractPaymentPeriodEnum.FREE_LISTING
  },
  {
    label: 'COMMISSION',
    value: OfferContractPaymentPeriodEnum.COMMISSION
  }
]

export const getOfferTypeTypesLabels: SelectOption<OfferTypeEnum>[] = [
  {
    label: 'LOCATION BASED',
    value: OfferTypeEnum.LOCATION_BASED
  },
  {
    label: 'LINK BASED',
    value: OfferTypeEnum.LINK_BASED
  }
]



export function getSelectedDays(slot: AvailabilitySlot): string[] {
  const values = [];
  if (slot.isAvailableOnMonday) {
    values.push('Mon');
  }
  if (slot.isAvailableOnTuesday) {
    values.push('Tue');
  }
  if (slot.isAvailableOnWednesday) {
    values.push('Wed');
  }
  if (slot.isAvailableOnThursday) {
    values.push('Thu');
  }
  if (slot.isAvailableOnFriday) {
    values.push('Fri');
  }
  if (slot.isAvailableOnSaturday) {
    values.push('Sat');
  }
  if (slot.isAvailableOnSunday) {
    values.push('Sun');
  }
  return values;
}

export function setAvailabilitySlotDay(slot: AvailabilitySlot, day: string, checked: boolean): void {
  switch (day) {
    case 'Mon':
      slot.isAvailableOnMonday = checked;
      break;
    case 'Tue':
      slot.isAvailableOnTuesday = checked;
      break;
    case 'Wed':
      slot.isAvailableOnWednesday = checked;
      break;
    case 'Thu':
      slot.isAvailableOnThursday = checked;
      break;
    case 'Fri':
      slot.isAvailableOnFriday = checked;
      break;
    case 'Sat':
      slot.isAvailableOnSaturday = checked;
      break;
    case 'Sun':
      slot.isAvailableOnSunday = checked;
      break;
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/interfaces/offer.dropdowns.ts